@if (!eventQuickSwitch) {
    <span [i18n]="message" data-crlat="noEventsFound"></span>
} @else {
    <span class="no-events" [ngClass]="{ 'no-events-coral-desktop': isCoral }"
        ><span [i18n]="'app.noEventsToShow'" class="no-events-message" data-crlat="noEventsFound"></span
    ></span>
}
